import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import Btc from './Btc';
import Alt from './Alt';
import Stock from './Stock';
import FearGreed from './FearGreed';
import ManageModal from '../ManageModal';

function Ticker() {
  const location = useLocation();
  const navigate = useNavigate();

  const [symbols, setSymbols] = useState(() => {
    return JSON.parse(localStorage.getItem('symbols')) || ['00700', 'SH510300'];
  });

  const [altSymbols, setAltSymbols] = useState(() => {
    return (
      JSON.parse(localStorage.getItem('altSymbols')) || ['ETHBTC', 'UNIBTC']
    );
  });

  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem('logined')) {
      navigate('/?redirect=' + encodeURI(location.pathname));
    }
  }, [location, navigate]);

  const updateSymbols = (newSymbols) => {
    setSymbols(newSymbols);
    localStorage.setItem('symbols', JSON.stringify(newSymbols));
  };

  const updateAltSymbols = (newAltSymbols) => {
    setAltSymbols(newAltSymbols);
    localStorage.setItem('altSymbols', JSON.stringify(newAltSymbols));
  };

  return (
    <div style={{ paddingBottom: '60px', textAlign: 'center' }}>
      <Btc />
      <Stock symbols={symbols} />
      <Alt symbols={altSymbols} />
      <FearGreed />
      <Button
        type="primary"
        style={{ marginTop: '20px' }}
        onClick={() => setShowModal(true)}
      >
        管理自选
      </Button>

      <ManageModal
        visible={showModal}
        onClose={() => setShowModal(false)}
        symbols={symbols}
        altSymbols={altSymbols}
        updateSymbols={updateSymbols}
        updateAltSymbols={updateAltSymbols}
      />
    </div>
  );
}

export default Ticker;
